<script lang="ts">
  import MainMenu from "../components/MainMenu/MainMenu.svelte";
  import BaseLayout from "./BaseLayout.svelte";
</script>

<BaseLayout>
  <div class="flex-layout">
    <MainMenu />

    <div class="flex-layout-content">
      <div class="flex-layout-content-inner">
        <slot />
      </div>
    </div>
  </div>
</BaseLayout>

<style>
  .flex-layout {
    display: flex;
    flex-direction: row;
    flex: 1;
    max-height: calc(100% - 4rem); /* must match header navbar height */
  }

  .flex-layout-content {
    animation: fadein 0.8s;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    height: 100%;
  }

  .flex-layout-content-inner {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    height: 100%;
    padding: 1rem 2rem;
    margin: 0;
  }
</style>
